import React from 'react'
import { browserHistory } from 'react-router'

class AppTopUpPage extends React.Component {
    componentDidMount () {
        browserHistory.replace('/specials/app/iap_recharge')
    }
    render() {
        return (
            <div style={{width: '100%', height: '100vh', backgroundColor: '#fff', textAlign: 'center'}}>
                
            </div>
        )
    }
}

export default AppTopUpPage


// WEBPACK FOOTER //
// ./src/pages/AppTopUpPage.js